"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchProvider = SearchProvider;
exports.useSearchContext = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _reactSingletonContext = require("react-singleton-context");
var _useSearchField = _interopRequireDefault(require("../hooks/useSearchField"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SearchContext = (0, _reactSingletonContext.createRegisteredContext)('ContainerTableSearchContext', undefined);
const useSearchContext = () => {
  const context = React.useContext(SearchContext);
  if (!context) {
    throw new Error('useSearchContext should be used within a SearchProvider');
  }
  return context;
};

/**
 * @ignore - internal component.
 */
exports.useSearchContext = useSearchContext;
function SearchProvider(props) {
  const {
    searchValue,
    handleChangeInput
  } = (0, _useSearchField.default)();
  const values = React.useMemo(() => ({
    searchValue,
    handleSearchInput: handleChangeInput
  }), [searchValue, handleChangeInput]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SearchContext.Provider, (0, _extends2.default)({
    value: values
  }, props));
}